import React,{Component} from 'react';

import './Presskit.less';

const Presskit = ({res,data}) => {
  const {presskit} = data;
  return (
    <div className={`presskit ${res}`}>
      {presskit.de && <a className='download download-left' href={presskit.de}><span className='download-icon' /><span className='inner-button-text'>Pressekit (DE)</span></a>}
      {presskit.en && <a className='download' href={presskit.en}><span className='download-icon' /><span className='inner-button-text'>Pressekit (EN)</span></a>}
    </div>
  )
}

export default Presskit



// WEBPACK FOOTER //
// ./src/components/sections/Presskit.js